<template>
  <!-- Table Container Card -->
  <div>
    <add-new-role
      :is-add-new-role-sidebar-active.sync="isAddNewRoleSidebarActive"
      @clickaddNewRole="clickaddNewRole"
    />
    <add-edit-role
      :is-add-edit-role-sidebar-active.sync="isAddEditRoleSidebarActive"
      :editRoleData="editRoleData"
      @clickaddEditRole="clickaddEditRole"
    />
    <assign-permission-role
      :is-assign-permission-role-sidebar-active.sync="
        isAssignPermissionRoleSidebarActive
      "
      :assignPermission="assignPermission"
      @clickAssignPermission="clickAssignPermission"
    />
    <b-card no-body>
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <!-- <b-breadcrumb :items="items" /> -->

            <!-- <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label> -->
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="6" v-if="addpermissionHideButton == true">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                @input="roleFilter"
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />
              <b-button
                variant="primary"
                @click="isAddNewRoleSidebarActive = true"
              >
                <span class="text-nowrap">Add Role</span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>
      <!-- <span v-for="level_data in table_data" :key="level_data.Level">
        {{level_data}}
      </span> -->
      <b-overlay :show="show" rounded="sm">
        <b-table-simple
          v-if="addpermissionHideButton == true"
          hover
          caption-top
          responsive
          class="rounded-bottom mb-0"
        >
          <b-thead head-variant="light">
            <b-tr>
              <b-th>No.</b-th>
              <b-th>Role Name</b-th>
              <b-th>Permission Name</b-th>
              <b-th>Action</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <template v-for="(role_data, index) in table_data">
              <b-tr :key="index + 'fasfas'">
                <b-td>
                  {{ index + 1 }}
                </b-td>
                <b-td>
                  {{ role_data.name }}
                </b-td>
                <b-td>
                  <span
                    v-for="(permissionName, index) in role_data.permissionName"
                    :key="index"
                  >
                    <b-badge pill variant="primary">
                      {{ permissionName }}
                      <feather-icon
                        style="margin-left: 10px"
                        @click="confirmText(role_data._id, index)"
                        icon="TrashIcon"
                      />
                    </b-badge>

                    <br />
                  </span>
                </b-td>
                <!-- <b-td>
                <b-button
                  variant="secondary"
                  @click="
                    AddPermissionInRole(role_data._id, role_data.permissionName)
                  "
                >
                  <span class="text-nowrap">Assign Permission</span>
                </b-button>
              </b-td> -->
                <!-- <b-td> </b-td>
              <b-td> </b-td> -->
                <!-- <b-td> </b-td> -->
                <!-- <b-td>
                <b-button
                  variant="primary"
                  @click="OpenEditRoleSideBar(role_data._id, role_data.name)"
                >
                  <span class="text-nowrap">Edit</span>
                </b-button>
              </b-td> -->
                <!-- <b-td>
                <b-button variant="danger" @click="deleterRole(role_data._id)">
                  <span class="text-nowrap">Delete</span>
                </b-button>
              </b-td> -->
                <b-td>
                  <b-dropdown variant="link" no-caret>
                    <template #button-content>
                      <feather-icon
                        icon="MoreVerticalIcon"
                        size="16"
                        class="align-middle text-body"
                      />
                    </template>
                    <!-- <b-dropdown-item
                    @click="
                      AddPermissionInRole(
                        role_data._id,
                        role_data.permissionName
                      )
                    "
                  >
                    <feather-icon height="20px" width="20px" icon="AwardIcon" />
                    <span class="align-middle ml-50">Assign Permission</span>
                  </b-dropdown-item> -->
                    <b-dropdown-item
                      @click="
                        OpenEditRoleSideBar(
                          role_data._id,
                          role_data.name,
                          role_data
                        )
                      "
                    >
                      <feather-icon icon="EditIcon" />
                      <span class="align-middle ml-50">Edit</span>
                    </b-dropdown-item>

                    <b-dropdown-item @click="deleterRole(role_data._id)">
                      <feather-icon icon="TrashIcon" />
                      <span class="align-middle ml-50">Delete</span>
                    </b-dropdown-item>
                  </b-dropdown>
                </b-td>
              </b-tr>
            </template>

            <!-- <b-tr> -->
          </b-tbody>
        </b-table-simple>
      </b-overlay>
      <!-- {{ this.table_data.level }} -->
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BOverlay,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BTableSimple,
  BThead,
  BTr,
  BTh,
  BTd,
  BTbody,
  BTfoot,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { BBreadcrumb } from "bootstrap-vue";
// import Vue from "vue";
// import VueSwal from "vue-swal";
import Swal from "sweetalert2/dist/sweetalert2.js";

import "sweetalert2/src/sweetalert2.scss";
// Vue.use(VueSwal);
// import { BButton } from 'bootstrap-vue'
// import Ripple from 'vue-ripple-directive'
import AddNewRole from "./app/list/users-list/AddNewRole.vue";
import AddEditRole from "./app/list/users-list/AddEditRole.vue";
import AssignPermissionRole from "./app/list/users-list/AssignPermissionRole.vue";
import axios from "axios";
import Ripple from "vue-ripple-directive";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
export default {
  components: {
    AddNewRole,
    AddEditRole,
    AssignPermissionRole,
    BBreadcrumb,
    BCard,
    BOverlay,
    BRow,
    ToastificationContent,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    BTableSimple,
    BThead,
    BTr,
    BTh,
    BTd,
    BTbody,
    BTfoot,
    vSelect,
  },
  directives: {
    Ripple,
  },

  data() {
    return {
      table_data: {},
      isAddEditRoleSidebarActive: false,
      isAddNewRoleSidebarActive: false,
      isAssignPermissionRoleSidebarActive: false,
      alertMessageDeleteRole: "",
      alertMessageEditRole: "",
      show: false,
      searchQuery: "",
      table_: [],
      editRoleData: {
        id: "",
        name: "",
      },
      assignPermission: {
        id: "",
      },
      addpermissionHideButton: false,
    };
  },
  created() {
    this.gettabledata();
  },

  methods: {
    confirmText(i, j) {
      Swal.fire({
        title: "Are you sure?",
        text: "Do You want to delete this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          // Swal.fire("Deleted!", "Your file has been deleted.", "success");
          this.delete_permission_from_role(i, j);
        }
      });
    },
    roleFilter() {
      this.show = true;
      setTimeout(() => {
        if (this.searchQuery.trim().length > 0) {
          // console.log('this.searchQuery',this.searchQuery)
          let finaldata = this.table_.filter((item) => {
            // console.log(item.title);
            if (item.name) {
              // console.log()
              return this.searchQuery
                .toLowerCase()
                .split(" ")
                .every((v) => item.name.toLowerCase().includes(v));
            }
          });
          this.table_data = finaldata;
          this.show = false;
        } else {
          this.table_data = this.table_;
          this.show = false;
        }
      }, 1000);
    },
    delete_permission_from_role(role_id, index) {
      // console.log("aaaaaaaaaaa",this.table_data)
      // return "done";
      // var newId = this.table_data.permission_ids[data];/
      var deleted = {
        role_id: "",
        permission_id_index: "",
      };
      deleted.role_id = role_id;
      deleted.permission_id_index = index;
      axios
        .post(
          process.env.VUE_APP_API_URL + "/role/permission/delete",
          deleted,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("_t"),
            },
          }
        )
        .then((response) => {
          // console.log(response);
          if (response.data == "Successfully Remove") {
            this.removeRole("success");
          } else {
            this.removeRolereject("danger");
          }

          this.gettabledata();
        });
    },
    removeRole(variant) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Notification",
          icon: "BellIcon",
          text: "Remove Permission Successfully ",
          variant,
        },
      });
    },
    removeRolereject(variant) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Notification",
          icon: "BellIcon",
          text: "Remove permission fail.Try again ",
          variant,
        },
      });
    },
    AddPermissionInRole(id, permission) {
      this.isAssignPermissionRoleSidebarActive = true;
      this.assignPermission.id = id;
      this.assignPermission.permission = permission;
      // console.log("role_iddddddddd",id);
    },
    deleterRole(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "Do You want to delete this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          // Swal.fire("Deleted!", "Your file has been deleted.", "success");
          var deleteId = {
            id: "",
          };
          deleteId.id = id;
          axios
            .post(process.env.VUE_APP_API_URL + "/role/delete", deleteId, {
              headers: {
                Authorization: "Bearer " + localStorage.getItem("_t"),
              },
            })
            .then((response) => {
              this.alertMessageDeleteRole = response.data;
              this.addDeleteRole("success");

              this.gettabledata();
            });
        }
      });
    },
    //  {

    //   },
    addDeleteRole(variant) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Notification",
          icon: "BellIcon",
          text: this.alertMessageDeleteRole,
          variant,
        },
      });
    },
    addDeleteRoleReject(variant) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Notification",
          icon: "BellIcon",
          text: this.alertMessageDeleteRole,
          variant,
        },
      });
    },
    clickaddEditRole(EditRole) {
      // console.log(EditRole)
      axios
        .post(process.env.VUE_APP_API_URL + "/role/edit", EditRole, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("_t"),
          },
        })
        .then((response) => {
          this.alertMessageEditRole = response.data;
          this.addEditRole("success");
          // console.log(response);
          // if (response.data != "duplicate role") {
          //   this.addEditRole("success", "top-left");
          // } else {
          //   this.addEditRoleReject("danger", "top-left");
          // }

          this.gettabledata();
        });
    },
    addEditRole(variant) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Notification",
          icon: "BellIcon",
          text: this.alertMessageEditRole,
          variant,
        },
      });
    },
    OpenEditRoleSideBar(id, name, role_data) {
      this.editRoleData.id = id;
      this.editRoleData.name = name;
      if (role_data.permission_ids) {
        if (role_data.permission_ids.length > 0) {
          this.editRoleData.OldObject = role_data.permission_ids;
        }
      } else {
        this.editRoleData.OldObject = [];
      }
      // console.log('this.editRoleData',this.editRoleData);
      // this.editRoleData.OldObject = role_data.permission_ids;
      this.isAddEditRoleSidebarActive = true;
      // console.log(id);
      // console.log(name);
    },
    clickaddNewRole(add_role_data) {
      axios
        .post(process.env.VUE_APP_API_URL + "/role/add", add_role_data, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("_t"),
          },
        })
        .then((response) => {
          if (response.data != "duplicate role") {
            this.addNewRoleSuccess("success");
          } else {
            this.addNewURoleReject("danger");
          }

          this.gettabledata();
        });
    },
    clickAssignPermission(assign_permission) {
      axios
        .post(
          process.env.VUE_APP_API_URL + "/assign_permission_data",
          assign_permission
        )
        .then((response) => {
          this.gettabledata();
        });
    },
    addNewURoleReject(variant) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Notification",
          icon: "BellIcon",
          text: "Duplicate role please add with another name",
          variant,
        },
      });
    },
    addNewRoleSuccess(variant) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Notification",
          icon: "BellIcon",
          text: "Role Successfully Added",
          variant,
        },
      });
    },
    gettabledata: function () {
      //
      axios
        .get(process.env.VUE_APP_API_URL + "/roles/data/all", {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("_t"),
          },
        })
        .then((get_response) => {
          if (get_response.data.length == 0) {
            this.addpermissionHideButton = false;
          } else {
            this.addpermissionHideButton = true;
            this.table_ = get_response.data;
            this.table_data = get_response.data;
          }
        });
    },
  },
};
</script>


<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
